import React, { useEffect, useState, useRef } from 'react'
import { useHistory } from 'react-router'
import ReactPaginate from 'react-paginate'
import airfreightratsServices from '../../Services/airfreightratesServices'
import { ChangeStatus } from '../../Components'
import Loader from '../../Components/Loader'

export const UsersList = () => {

    const [usersList, setUsersList] = useState([])
    const [pagination, setPagination] = useState({ page: 1, limit: 10 })
    const [currentPage, setCurrentPage] = useState(1)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [loader, setLoader] = useState(true)
    // eslint-disable-next-line
    const [countryValue, setCountryValue] = useState('')

    const history = useHistory()
    const imgRef = useRef()

    useEffect(() => {
        getUsersList()
        // eslint-disable-next-line
    }, [currentPage])

    const getUsersList = (countryId = countryValue ? countryValue.label : '') => {
        let param = { ...pagination, page: currentPage }
        if (countryId) {
            param['search'] = countryId
            param['page'] = 1
        }
        airfreightratsServices.getAirfreightrates(param).then(res => {
            if (res.status) {
                setLoader(false)
                setUsersList(res.data)
                setPagination(res.pagination)
            } else {
                setLoader(false)
            }
        })
    }

    const onModalSubmit = () => {
        // let postData = {
        //     airfreightrats_id: isModalOpen._id,
        //     airfreight_status: isModalOpen.airfreight_status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
        // }
        // airfreightratsServices.updateAirfreightratestatus(postData).then(res => {
        //     if (res.status) {
        setIsModalOpen(false)
        // getUsersList()
        //     }
        // })
    }

    const onPageChangeEvent = (e) => {
        setLoader(true)
        setCurrentPage(e.selected + 1)
    }

    // const onSelectCountry = (e,) => {
    //     setCountryValue(e)
    //     getUsersList(e.value)
    // }

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div>
                            <button className="btn btn-primary w-sm waves-effect waves-light mx-3"
                                onClick={() => history.push('/add-user')}
                            >Add User
                            </button>
                            <input ref={imgRef} type="file" className="d-none" />
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>S no.</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Contact No.</th>
                                        <th>Nationality</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usersList.length > 0 && usersList.map((item, key) => (
                                        <tr key={key}>
                                            <td className="text-body fw-bold">{((pagination.page - 1) * pagination.limit) + (key + 1)}</td>
                                            <td>Demo</td>
                                            <td>sky@gmail.com</td>
                                            <td>6598985478</td>
                                            <td>India</td>
                                            <td>
                                                <span
                                                    className={"badge rounded-pill font-size-12 pointer" + (item.airfreight_status === 'ACTIVE' ? ' bg-success' : ' bg-soft-danger')}
                                                    onClick={() => setIsModalOpen(item)}
                                                >{item.airfreight_status}</span>
                                            </td>
                                            <td>
                                                {/* Button trigger modal */}
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                >
                                                    Follow up
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {usersList.length <= 0 && !loader &&
                                <div className="text-center w-100 bg-warning my-5">
                                    <h6 className="py-2"> list not available </h6>
                                </div>
                            }
                        </div>
                    </div>
                    {usersList.length > 0 && pagination.totalRecord > pagination.limit &&
                        <ReactPaginate
                            previousLabel={<img src="assets/images/prev.svg" height={15} alt="not found" />}
                            forcePage={currentPage - 1}
                            nextLabel={<img src="assets/images/next.svg" height={15} alt="not found" />}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={3}
                            onPageChange={(e) => onPageChangeEvent(e)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    }
                    <Loader isShow={loader} />
                </div>
                {Boolean(isModalOpen) &&
                    <ChangeStatus
                        isOpen={Boolean(isModalOpen)}
                        title='Update Status'
                        message={`Are you sure want to ${isModalOpen.airfreight_status === 'ACTIVE' ? 'Inactive' : 'Active'} status ?`}
                        onSubmitEvent={() => onModalSubmit()}
                        handleClose={() => setIsModalOpen(false)}
                    />
                }

                {Boolean(deleteModalOpen) &&
                    <ChangeStatus
                        isOpen={Boolean(deleteModalOpen)}
                        title='Delete'
                        message={`Are you sure want to delete?`}
                        onSubmitEvent={() => setDeleteModalOpen(false)}
                        handleClose={() => setDeleteModalOpen(false)}
                    />
                }
            </div>
        </div>
    )
}
